export const getStyle = ({
  bgColor,
  bgColorHover,
  badgeColor,
  ctaBgColor,
  ctaBgHoverColor,
  ctaDisabledColor,
  hasVideo,
  isMobile
}) => {
  return `
    <style>
      .main-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        max-width: ${isMobile ? '300px' : '350px'};
        height: 100%;
        text-decoration: none;
        color: #040404;
        transition: background-color 0.5s ease;
        border-radius: 5px;
        background-color: ${bgColor};
      }

      .main-wrapper:hover {
        background-color: ${bgColorHover};
      }

      .main-wrapper:hover product-video{
        opacity: 1;
      }

      .main-wrapper:hover product-image{
        opacity: ${hasVideo ? 0 : 1};
      }

      product-video {
        opacity: 0;
        transition: opacity 0.5s ease;
        position: absolute;
        top: 0;
      }

      product-image {
        transition: opacity 0.5s ease;
      }

      .image-wrapper {
        width: 100%;
        position: relative;
      }

      .bottom-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
        padding: ${isMobile ? '2px 5px' : '20px 10px'};
      }

      .info-wrapper {
        display:flex;
        justify-content: space-between;
        gap: 5px;
        flex-wrap: wrap;
      }

      .price {
        font-size: ${isMobile ? '13px' : '16px'};
        line-height: ${isMobile ? '18px' : '24px'};
      }

      .title {
        width: ${isMobile ? '100%' : '65%'};
        font-size: ${isMobile ? '16px' : '23px'};
        line-height: ${isMobile ? '21px' : '30px'};
      }

      .badge {
        font-family: 'GT-America-Standard-Medium';
        position: absolute;
        top: ${isMobile ? '8px' : '12px'};
        left: ${isMobile ? '8px' : '12px'};
        font-size: ${isMobile ? '10px' : '12px'};
        background: ${badgeColor};
        border-radius: 6px;
        color:#3a3e43;
        padding: 4px 10px;
        text-transform: uppercase;
        line-height: 18px;
      }

      .sold-out {
        background: #C0392B;
        color: #fff;
      }

      .cta {
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: center;
        padding: 11px 24px;
        border-radius: 11px;
        margin-top: 20px;
        font-size: ${isMobile ? '11px' : '14px'};
        text-transform: uppercase;
        color: ${ctaBgHoverColor};
        background: ${ctaBgColor};
        border: 1px solid ${ctaBgHoverColor};
        transition: background 0.5s ease;
        cursor: pointer;
      }

      .cta:hover {
        background: ${ctaBgHoverColor};
        color: #ffff;
      }

      .cta:hover .line {
        background: ${ctaBgColor};
      }

      .cta:disabled {
        color: #717575 !important;
        background: ${ctaDisabledColor} !important;
        border: 1px solid ${ctaDisabledColor} !important;
        cursor: not-allowed;
      }

      .line {
        flex: 1;
        height: 1px;
        background: ${ctaBgHoverColor};
        max-width: 35px;
      }

      .product-type {
        font-family: 'GT-America-Condensed-Regular';
        font-size: ${isMobile ? '12px' : '14px'};
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 2.8px;
        line-height: 20px;
        margin: 0 0 10px;
      }
    </style>
  `;
};
